export const iconFontAwesomeUsersPeopleUserShield = (
	<i className="fa-solid fa-user-shield"></i>
);
